import { render, staticRenderFns } from "./ReSendQueueSucessModal.vue?vue&type=template&id=ab977fb8&scoped=true&"
import script from "./ReSendQueueSucessModal.vue?vue&type=script&lang=js&"
export * from "./ReSendQueueSucessModal.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQueueSucessModal.vue?vue&type=style&index=0&id=ab977fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab977fb8",
  null
  
)

export default component.exports